import './common/rem'
import './common/theme/index.css'
import './style/base.less'
import Vue from 'vue'
import router from './router'
import store from './store'
import utils from './common'
import http, { Axios } from './common/http.js'
import ui from './common/ui'
import components from './components'
import App from './App'

import FastClick from 'fastclick';
FastClick.attach(document.body);

Vue.use(utils)
Vue.use(ui)
Vue.use(components)
Vue.prototype.$http = http
Vue.prototype.$axios = Axios

Vue.config.productionTip = true

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js